(()=>{
 'use strict';
 const office=window.FultonsStressless?.office||[];
 if(!office.length||!window.FultonsPriceTrial)return;
 window.FultonsProductOptions=window.FultonsProductOptions||{};
 for(const model of office){
  const amounts=model.configurations.flatMap(configuration=>configuration.prices.map(grade=>grade.price)).filter(value=>Number.isFinite(value)&&value>0);
  if(amounts.length&&!window.FultonsProductOptions[String(model.id)])window.FultonsProductOptions[String(model.id)]={fromPrice:Math.min(...amounts)};
 }
 const render=()=>{
  for(const card of document.querySelectorAll('.living-test__card[data-product-id]')){
   if(office.some(model=>String(model.id)===card.dataset.productId))card.querySelector('[data-stressless-card-price]')?.remove();
  }
  const id=new URL(location.href).searchParams.get('draft_product')||window.FultonsPriceTrial?.productId;
  const model=office.find(item=>String(item.id)===String(id));if(!model)return;
  const root=document.querySelector('#MainContent .catalogue-proof:not([hidden]),#MainContent .pdp-refined:not([hidden])');
  const description=root?.querySelector('.catalogue-proof__description,.pdp-refined__intro');
  if(!description||root.querySelector('[data-stressless-office]'))return;
  const options=document.createElement('div');options.dataset.stresslessOffice=model.key;description.append(options);
  document.dispatchEvent(new CustomEvent('fultons:catalogue-updated'));
 };
 document.addEventListener('fultons:catalogue-updated',render);
 if(document.readyState==='loading'||document.readyState==='interactive')document.addEventListener('DOMContentLoaded',render,{once:true});else render();
})();
